var map = {
	"./african-grey-parrot.mp3": "60c9",
	"./alligator.mp3": "acbd",
	"./alpaca.mp3": "9886",
	"./anteater.mp3": "2d56",
	"./antelope.mp3": "1008",
	"./ape.mp3": "9610",
	"./bat.mp3": "9f4e",
	"./bee.mp3": "f36b",
	"./bowhead-whale.mp3": "3707",
	"./buffalo.mp3": "ed26",
	"./butterfly.mp3": "a48b",
	"./camel.mp3": "e78f",
	"./cat.mp3": "a5a6",
	"./chicken.mp3": "0000",
	"./cow.mp3": "fe37",
	"./crow.mp3": "602e",
	"./dinosaur.mp3": "e13e",
	"./dog.mp3": "27dd",
	"./dove.mp3": "f558",
	"./duck.mp3": "d727",
	"./elephant.mp3": "145f",
	"./falcon.mp3": "b91b",
	"./ferret.mp3": "cc7b",
	"./frog.mp3": "7ee0",
	"./giraffe.mp3": "195d",
	"./guinea-pig.mp3": "0f47",
	"./hedgehog.mp3": "6a1d",
	"./hippopotamus.mp3": "5491",
	"./horse.mp3": "8102",
	"./humpback-whale.mp3": "ad92",
	"./hyena.mp3": "5833",
	"./komodo-dragon.mp3": "0be4",
	"./leopard.mp3": "3c33",
	"./lion.mp3": "3ff9",
	"./lizard.mp3": "3cb8",
	"./moose.mp3": "e7f2",
	"./otter.mp3": "9ec6",
	"./owl.mp3": "1f50",
	"./panda.mp3": "6a9e",
	"./penguin.mp3": "e218",
	"./pig.mp3": "5036",
	"./rabbit.mp3": "81c4",
	"./raccoon.mp3": "28d3",
	"./rat.mp3": "da0c",
	"./rattlesnake.mp3": "f54f",
	"./rhinoceros.mp3": "f5ab",
	"./robin.mp3": "076e",
	"./rooster.mp3": "a203",
	"./scorpion.mp3": "f1e9",
	"./shark.mp3": "ba0b",
	"./sheep.mp3": "caa8",
	"./swan.mp3": "1ef8",
	"./tiger.mp3": "5705",
	"./turkey.mp3": "a833",
	"./wolf.mp3": "f961",
	"./yak.mp3": "5724",
	"./zebra.mp3": "7475"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31a0";